import { h } from 'preact'
import styles from './image.module.css'
import { toSrcsetString } from '@nrk/dh-basis-mediainfo/render-utils'

export const Image = (props) => {
  const imageInfo = props.mediaInfo

  if (!props.source.id) {
    return <p>Mangler bilde-ID</p>
  }

  if (!imageInfo) {
    return <img alt="" />
  }

  const sizes = '(min-width: 590px) 590px, 100vw'
  return (
    <div className={styles.wrapper}>
      <picture>
        {imageInfo.sources.map((source) => {
          return <source type={source.type} srcset={toSrcsetString(source.srcset)} sizes={sizes} />
        })}
        <img
          className={styles.image}
          alt={imageInfo.title}
          width={imageInfo.naturalDimensions.width}
          height={imageInfo.naturalDimensions.height}
          sizes={sizes}
          loading="lazy"
        />
      </picture>
      <figcaption>
        <p>{props.text}</p>
        <small>
          {imageInfo.creditText ? `${imageInfo.category ?? 'Foto'}: ${imageInfo.creditText}` : ''}
        </small>
      </figcaption>
    </div>
  )
}
